export class SendCodePageSetting {
    sendCodeText: string;

    ttl: number;

    hash: string;

    constructor(sendCodeText: string, ttl: number, hash: string) {
        this.sendCodeText = sendCodeText;
        this.ttl = ttl;
        this.hash = hash;
    }
}
